export default __webpack_public_path__ + "static/media/building.e849cdfa.gltf";